// Single source of truth for AZ City PAC contribution links.
// PayPal.me supports an optional amount appended to the path (e.g. /100).
export const PAYPAL_URL = 'https://paypal.me/AZCITYPAC'

export function buildDonateUrl(amount?: number): string {
  if (!amount || amount <= 0) return PAYPAL_URL
  return `${PAYPAL_URL}/${Math.round(amount)}`
}
